<template>
  <form>
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon" :title="$t('general.back')" @click.prevent="backButton"><i class="ti-arrow-left"></i></a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="route && route.params && route.params.id" @click.prevent="deleteOrderScreen" style="padding: 7px 10px; margin-right: 20px;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-12 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>ID</label>
                  <input type="number"
                    disabled
                    placeholder="ID"
                    v-model="model.id"
                    class="form-control">
                </div>

                <div class="form-group">
                  <label>Name</label>
                  <input type="text"
                    placeholder="name"
                    v-validate="modelValidate.name"
                    v-model="model.name"
                    class="form-control">
                </div>

                <div class="form-group mar-to-15 label-input">
                  <label>Type</label>
                  <select class="form-control color-option-default" name="type_name" v-model="model.type_name" v-validate="modelValidate.type_name">
                    <option value="CAS">CAS</option>
                    <option value="CAS_II">CAS II</option>
                    <option value="Mettler_Toledo">Mettler Toledo</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>Port</label>
                  <input type="text"
                    placeholder="COM4"
                    v-validate="modelValidate.port"
                    v-model="model.port"
                    class="form-control">
                </div>

                <div class="form-group">
                  <label>Baud Rate</label>
                  <input type="number"
                    placeholder="9600"
                    v-validate="modelValidate.baudRate"
                    v-model="model.baudRate"
                    class="form-control">
                </div>

                <div class="form-group">
                  <label>Timeout Ms</label>
                  <input type="number"
                    placeholder="5000"
                    v-validate="modelValidate.timeoutMs"
                    v-model="model.timeoutMs"
                    class="form-control">
                </div>

                <!-- <div class="form-group">
                  <p-switch v-model="model.cash_register_auto_dp_before_z" type="success" ></p-switch>
                  <label> Emite automat dispozitie de plata la generarea raportului Z</label>
                </div> -->

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Select} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import BackgroundColorPicker from 'src/components/UIComponents/BackgroundColorPicker.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      PSwitch,
      BackgroundColorPicker,
      [Button.name]: Button,
      [Input.name]: Input,
      [Select.name]: Select
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.getData()
    },
    data () {
      return {
        id: this.value,
        locations: [],
        table_maps: [],
        model: {
          'id': 0,
          'type': 1,
          'name': null,
          'type_name': 'CAS',
          'port': null,
          'baudRate': null,
          'timeoutMs': null
        },
        modelValidate: {
          name: {required: true},
          port: {required: true},
          baudRate: {required: true},
          timeoutMs: {required: true},
          type_name: {required: true}
        },
        loading: true,
        colors: {
          defult: '#c850c0',
          black: '#000'
        }
      }
    },
    methods: {
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy)
      },
      getData () {
        var id = this.id || this.route.params.id
        if (id) {
          let data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/cantar/' + id, 'GET', data, (response) => {
            if (response.status) {
              this.model = response.data.cantar
              if (this.model.location_id) {
                this.changeLocation(true)
              }
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveTable() }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      saveTable () {
        this.loading = true

        let data = {
          ...this.model,
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany')
        }

        var id = this.id || this.route.params.id
        let url = ''
        let request = ''
        if (id) {
          url = '/cantar/' + id
          request = 'PUT'
        } else {
          url = '/cantar/add'
          request = 'POST'
        }
        this.apiRequest(url, request, data, (response) => {
          if (response.status === true) {
            this.errors.clear()
            if (request === 'POST') {
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
              // this.router.push('/cantar/edit/' + response.data.cantar.id)
            } else {
              this.backButton()
            }
            swal(
              {
                title: '',
                text: this.$t('settingTable.tableSave'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
          } else {
            this.handleErrors(response.errors)
          }
          this.loading = false
        })
      },
      deleteOrderScreen () {
        this.loadingReset = true
        var id = this.id || this.route.params.id
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/cantar/' + id, 'DELETE', data, (response) => {
          if (response.status) {
            swal({'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.backButton()
          } else {
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
          this.loadingReset = false
        })
      },
      changeLocation (doNotEmptyModel = false) {
        if (!doNotEmptyModel) {
          this.model.table_maps_ids = []
        }
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_id: this.model.location_id
        }
        this.loading = true
        this.apiRequest('/pos/all/map', 'GET', data, (response) => {
          if (response.status) {
            this.table_maps = response.data.cantar
          }
          this.loading = false
        })
      },
      backButton () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
        // this.router.push('/pos/tabs?tabIndex=6')
      },
      updateColor (value) {
        this.model.background_color = value
      }
    }
  }
</script>
<style scoped lang="scss">
  .copy_link {
    margin-top: 10px;
    width: 100%;
  }
  .upload-demo input[type="file"]{ display: none; }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>
<style>
  span.el-select__tags-text {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/cantar/CantarForm.vue